import React, { Fragment, useState } from "react";
import { useBookmakerLogic } from "../../useLogic/useBookmakerLogic";
import { useContextSelector } from "use-context-selector";
import BetSlipContext from "../../../context/BetSlipContext";
import { formatWithCommas } from "../../../Utils/Toast";
import { isEmpty, isNumber } from "lodash";
import RenderBookmakerOdds from "./RenderBookmakerOdds";
import BetSlipSkyWeb from "./BetSlip";
import Message from "./Message";

const BookmakerSkyWeb = ({
  runner,
  backOdds,
  layOdds,
  oldBack,
  oldLay,
  profileData,
  marketName,
  detail,
  ms,
  typeGame,
  user,
  marketId,
  totalMatched,
  addToFavioute,
  position,
}) => {
  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });
  const toastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.toastObject;
  });
  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });
  const setToastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setToastObject;
  });
  const { localLimit, handelChange, checkArrays, fav } = useBookmakerLogic({
    backOdds,
    layOdds,
    oldBack,
    oldLay,
    profileData,
    marketName,
    detail,
    ms,
    typeGame,
    user,
    marketId,
    totalMatched,
    position,
  });

  return (
    <div id="bookMakerWrap" className="bets-wrap bookmaker_bet" style={{}}>
      <div id="bookMakerSpecialBet" className="multi-pin-title">
        <h3>
          <a
            id="multiMarketPin"
            className="add-pin"
            title="Add to Multi Markets"
          >
            Add Pin
          </a>
          <strong>Bookmaker Market</strong>
          <span>| Zero Commission</span>
        </h3>
      </div>
      <table
        id="bookMakerMarketList"
        className="bets bets-bookmaker"
        style={{}}
      >
        <colgroup>
          <col span={1} width={280} />
          <col span={6} width={70} />
        </colgroup>
        <tbody>
          <tr className="colgroup-adjust">
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
          </tr>
        </tbody>
        <tbody
          name="market-more"
          id="bookMakerMarket_34924384_289720"
          style={{ display: "table-row-group" }}
        >
          <tr className="market-more add-info">
            <td colSpan={7}>
              <h3 id="market-name" className>
                Bookmaker
              </h3>
              <ul className="bookmaker-info">
                <li>
                  <span>Min</span>
                  <data id="min">
                    {formatWithCommas(localLimit?.minAmount)}
                  </data>
                </li>
                <li>
                  <span>Max</span>
                  <data id="max">
                    {formatWithCommas(localLimit?.maxAmount)}
                  </data>
                </li>
                <li id="rebate" style={{ display: "none" }}>
                  <span>Rebate</span>
                  <data id="rebate-val" />
                </li>
              </ul>
            </td>
          </tr>
          <tr className="bet-all">
            <td colSpan={3} />
            <td>Back</td>
            <td>Lay</td>
            <td className="refer-book" colSpan={2} />
          </tr>

          {runner?.map((item, index) => {
            let odds_back = backOdds
              ?.filter((t) => t.name === item.runnerName)
              ?.sort((a, b) => a.rt - b.rt);

            let odds_lay = layOdds
              ?.filter((t) => t.name === item.runnerName)
              ?.sort((a, b) => b.rt - a.rt);

            let old_back = oldBack
              ?.filter((t) => t.name === item.runnerName)
              ?.sort((a, b) => b.rt - a.rt);

            let old_lay = oldLay
              ?.filter((t) => t.name === item.runnerName)
              ?.sort((a, b) => b.rt - a.rt);

            let disabelBack =
              "lockBackBets" in item ? item?.lockBackBets : false;
            let disabelLay = "lockLayBets" in item ? item?.lockLayBets : false;

            const limitOdds = localLimit?.oddsLimit ?? 0;

            const backLimitExceeded = odds_back?.some((o) => o.rt > limitOdds);
            const layLimitExceeded = odds_lay?.some((o) => o.rt > limitOdds);

            const finalDisableBack = disabelBack || backLimitExceeded;
            const finalDisableLay = disabelLay || layLimitExceeded;

            const disableFull = checkArrays(
              odds_back, // FULL array
              odds_lay, // FULL array
              localLimit // full limit object
            );
            return (
              <Fragment>
                {disableFull && (
                  <tr
                    id="bookMakerSuspend_34924384_289720_853433"
                    className="fancy-suspend-tr"
                  >
                    <th colSpan />
                    <td className="fancy-suspend-td" colSpan={6}>
                      <div id="suspendClass" className="fancy-suspend">
                        <span id="info">Suspend</span>
                      </div>
                    </td>
                  </tr>
                )}
                <tr
                  id="bookMakerSelection_34924384_289720_853432"
                  style={{ display: "table-row" }}
                  className={disableFull ? "disabled" : ""}
                >
                  <th className="predict">
                    <p id="runnerName">
                      {" "}
                      {item?.RunnerName || item?.runnerName}
                    </p>
                    {isNumber(item?.position) &&
                      position?.length > 0 &&
                      Math.abs(item?.position) > 0 && (
                        <span
                          id="withoutBet"
                          className={item?.position > 0 ? "win" : "lose"}
                        >
                          {isNumber(item?.position) &&
                          Math.abs(item?.position) > 0
                            ? item?.position > 0
                              ? Math?.abs(item?.position).toFixed(2)
                              : `(${Math.abs(item?.position).toFixed(2)})`
                            : ""}
                        </span>
                      )}
                    {Math.abs(item?.newPosition) >= 0 &&
                      showBetDialog &&
                      betSlipObject?.playType == typeGame &&
                      marketId == betSlipObject?.object?.newMarketId && (
                        <span
                          id="withBet"
                          className={`to-${
                            item?.newPosition > 0 ? "win" : "lose"
                          }`}
                        >
                          {item?.newPosition > 0
                            ? Math.abs(item?.newPosition).toFixed(2)
                            : `(${Math.abs(item?.newPosition).toFixed(2)})`}
                        </span>
                      )}
                  </th>
                  <RenderBookmakerOdds
                    component={typeGame}
                    index={index}
                    marketName={marketName}
                    item={item}
                    disabelBack={disableFull ? false : finalDisableBack}
                    disabeLay={disableFull ? false : finalDisableLay}
                    oldBack={old_back}
                    oldLay={old_lay}
                    disableFull={disableFull}
                    disabelLay={detail?.market == "Win" ? true : disabelLay}
                    isInPlay={
                      ["Win", "Winner"].includes(detail?.market)
                        ? true
                        : detail?.status == "in_play"
                        ? true
                        : false
                    }
                    handelChange={handelChange}
                    odds_lay={odds_lay}
                    odds_back={odds_back}
                    limit={localLimit}
                    indexObject={betSlipObject?.index}
                    ms={ms}
                    betType={betSlipObject?.betType}
                    active={
                      showBetDialog &&
                      marketId == betSlipObject?.newMarketId &&
                      item?.SelectionId == betSlipObject?.object?.SelectionId &&
                      "bookmaker" == betSlipObject?.playType
                    }
                  />
                </tr>{" "}
                {showBetDialog &&
                  betSlipObject?.teamName == item.runnerName &&
                  item?.SelectionId == betSlipObject?.object?.SelectionId &&
                  betSlipObject?.playType == "bookmaker" && (
                    <BetSlipSkyWeb />
                  )}{" "}
                {!isEmpty(toastObject?.message) &&
                  toastObject?.status &&
                  toastObject?.gameType == "bookmaker" &&
                  item?.SelectionId == toastObject?.id && (
                    <Message
                      toastObject={toastObject}
                      setToastObject={setToastObject}
                    />
                  )}
              </Fragment>
            );
          })}

       
        </tbody>
      </table>
    </div>
  );
};

export default BookmakerSkyWeb;
